import React, { useEffect, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { FaBoxOpen, FaMoneyBillTransfer } from "react-icons/fa6";
import { FaCartShopping } from "react-icons/fa6";
const FaSignOutAlt = require("react-icons/fa").FaSignOutAlt;
const FaBars = require("react-icons/fa").FaBars;
const FaUsersCog = require("react-icons/fa").FaUsersCog;
const FaHandshake = require("react-icons/fa").FaHandshake;
const FaChevronDown = require("react-icons/fa").FaChevronDown;
const RiDashboardFill = require("react-icons/ri").RiDashboardFill;

const DashboardLayout = () => {
  const [affiliateOpen, setAffiliateOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [profile, setProfile] = useState<{ name: string; role: string; photo: string } | null>(null);

  const handleLogout = () => {
    document.cookie.split(";").forEach((c) => {
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date(0).toUTCString() + ";path=/");
    });

    window.location.href = "/login/admin";
  };

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = document.cookie
          .split("; ")
          .find((row) => row.startsWith("token="))
          ?.split("=")[1];

        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/profile`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        if (!res.ok) throw new Error("Gagal mengambil profil");

        const data = await res.json();

        setProfile({
          name: data.data.name,
          photo: `${process.env.REACT_APP_STORAGE_URL}/profile/${data.data.photo}`,
          role: data.data.role?.name,
        });
      } catch (err) {
        console.error("Gagal fetch profile:", err);
      }
    };

    fetchProfile();
  }, []);

  return (
    <>
      <div className="flex min-h-screen bg-gray-100 font-signika">
        {/* Sidebar */}
        <aside
          className={`fixed z-40 top-0 left-0 h-screen w-52 bg-black2 text-primary2 p-4 transform transition-transform duration-300 ease-in-out
        ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} 
        md:translate-x-0 md:static md:block`}>
          <div className="mb-8">
            <img src="/images/logo.png" alt="" className="w-44 h-14" />
          </div>

          <nav className="flex flex-col gap-2 text-lg">
            <NavLink
              to="/dashboard/beranda"
              className={({ isActive }) => `flex items-center gap-2 px-2 py-2 rounded-md transition ${isActive ? "text-primary22 bg-yellow-400/20 font-semibold" : "text-white hover:text-yellow-400"}`}
              onClick={() => setSidebarOpen(false)}>
              <RiDashboardFill /> Dashboard
            </NavLink>

            <NavLink
              to="/dashboard/produk"
              className={({ isActive }) => `flex items-center gap-2 px-2 py-2 rounded-md transition ${isActive ? "text-primary2 bg-yellow-400/20 font-semibold" : "text-white hover:text-yellow-400"}`}
              onClick={() => setSidebarOpen(false)}>
              <FaBoxOpen /> Produk
            </NavLink>

            <NavLink
              to="/dashboard/order"
              className={({ isActive }) => `flex items-center gap-2 px-2 py-2 rounded-md transition ${isActive ? "text-primary2 bg-yellow-400/20 font-semibold" : "text-white hover:text-yellow-400"}`}
              onClick={() => setSidebarOpen(false)}>
              <FaCartShopping /> Order
            </NavLink>

            <NavLink
              to="/dashboard/admin"
              className={({ isActive }) => `flex items-center gap-2 px-2 py-2 rounded-md transition ${isActive ? "text-primary2 bg-yellow-400/20 font-semibold" : "text-white hover:text-yellow-400"}`}
              onClick={() => setSidebarOpen(false)}>
              <FaUsersCog /> Acount
            </NavLink>

            {/* Affiliate Menu */}
            <div>
              <button onClick={() => setAffiliateOpen(!affiliateOpen)} className="flex items-center justify-between w-full px-2 py-2 rounded-md text-white hover:text-yellow-400">
                <div className="flex items-center gap-2">
                  <FaHandshake /> Affiliate
                </div>

                <FaChevronDown className={`transition-transform ${affiliateOpen ? "rotate-180" : ""}`} />
              </button>

              {affiliateOpen && (
                <div className="ml-6 mt-2 flex flex-col gap-1 text-base">
                  <NavLink
                    to="/dashboard/affiliate/akun"
                    className={({ isActive }) => `px-2 py-1 rounded-md transition ${isActive ? "text-primary2 bg-yellow-400/20 font-semibold" : "text-gray-300 hover:text-yellow-400"}`}
                    onClick={() => setSidebarOpen(false)}>
                    Akun Affiliate
                  </NavLink>

                  <NavLink
                    to="/dashboard/affiliate/penjualan"
                    className={({ isActive }) => `px-2 py-1 rounded-md transition ${isActive ? "text-primary2 bg-yellow-400/20 font-semibold" : "text-gray-300 hover:text-yellow-400"}`}
                    onClick={() => setSidebarOpen(false)}>
                    Penjualan Affiliate
                  </NavLink>

                  <NavLink
                    to="/dashboard/affiliate/setkomisi"
                    className={({ isActive }) => `px-2 py-1 rounded-md transition ${isActive ? "text-primary2 bg-yellow-400/20 font-semibold" : "text-gray-300 hover:text-yellow-400"}`}
                    onClick={() => setSidebarOpen(false)}>
                    Set Komisi
                  </NavLink>
                </div>
              )}
            </div>
            <NavLink
              to="/dashboard/withdraw"
              className={({ isActive }) => `flex items-center gap-2 px-2 py-2 rounded-md transition ${isActive ? "text-primary2 bg-yellow-400/20 font-semibold" : "text-white hover:text-yellow-400"}`}
              onClick={() => setSidebarOpen(false)}>
              <FaMoneyBillTransfer /> Withdraw
            </NavLink>

            {/* <NavLink
              to="/dashboard/pengguna"
              className={({ isActive }) => `flex items-center gap-2 px-2 py-2 rounded-md transition ${isActive ? "text-primary2 bg-yellow-400/20 font-semibold" : "text-white hover:text-yellow-400"}`}
              onClick={() => setSidebarOpen(false)}>
              <FaUserFriends /> Pengguna
            </NavLink> */}

            <button onClick={handleLogout} className="flex items-center gap-2 px-2  text-white hover:text-red-400 mt-4">
              <FaSignOutAlt /> Logout
            </button>
          </nav>
        </aside>

        {/* Main content area */}
        <div className="flex-1 flex flex-col h-screen">
          {/* Top navbar */}
          <header>
            <div className="bg-white shadow px-4 py-3 sticky top-0 z-30">
              <div className="flex items-center justify-between">
                {/* Burger menu for mobile */}
                <button onClick={() => setSidebarOpen(!sidebarOpen)} className="text-black text-xl md:hidden">
                  <FaBars />
                </button>

                {/* Dummy placeholder untuk spacing */}
                <div className="hidden md:block w-8"></div>

                {/* Profile info */}
                <div className="flex justify-end items-center gap-3">
                  {profile ? (
                    <>
                      <div className="flex items-center gap-4">
                        <img src={profile.photo} alt="" className="w-10 h-10 rounded-full" />
                        <div>
                          <p className="text-lg  text-gray-800 font-semibold">{profile.name}</p>
                          <p className="text-sm font-medium text-gray-800 -mt-1">{profile.role}</p>
                        </div>
                      </div>
                    </>
                  ) : (
                    <p className="text-gray-500 text-sm">Memuat profil...</p>
                  )}
                </div>
              </div>
            </div>
          </header>

          {/* Outlet for page content */}
          <main className="p-4 flex-1 overflow-y-auto">
            <Outlet />
          </main>
        </div>
      </div>

      {/* Overlay (klik luar sidebar) */}
      {sidebarOpen && <div className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden" onClick={() => setSidebarOpen(false)} />}
    </>
  );
};

export default DashboardLayout;
